<template>
  <div id="commonMemberForm">
    <div class="common_tit_wrap">
      <div class="common_page_tit">
        <template v-if="from === 'joinForm'">계정 등록 신청</template>
        <template v-else-if="from === 'memberForm'">{{userPid == null ? '신규 사용자 등록' : '사용자 수정'}}</template>
        <template v-else-if="from === 'myInfoForm'">내 정보수정</template>
      </div>
      <div class="common_page_desc" v-if="from === 'joinForm'">
        관리자의 승인 이후, 사이트 이용이 가능합니다.
      </div>
    </div>
    <div class="common_form_wrap">
      <div class="common_form_box">
        <div class="common_form_box_tit">사이트 이용정보</div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap half_width">
            <label>ID<span class="fc_red">*</span></label>
            <div v-if="userPid == null">
              <input type="text" v-model="userId" placeholder="ID를 입력하세요"/>
              <div class="btn_inner_gray" @click="checkDuplicate">중복확인</div>
            </div>
            <div v-else>
              <input type="text" v-model="userId" readonly/>
            </div>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap one_third_width">
            <label>패스워드<span class="fc_red">*</span></label>
            <div>
              <input type="password" v-model="password" placeholder="패스워드를 입력하세요"/>
            </div>
          </div>
<!--        </div>-->
<!--        <div class="common_form_box_content">-->
          <div class="common_form_input_wrap one_third_width">
            <label>패스워드 확인<span class="fc_red">*</span></label>
            <div>
              <input type="password" v-model="passwordConfirm" placeholder="패스워드를 다시 입력하세요"/>
            </div>
          </div>
          <div class="common_form_input_wrap one_third_width" style="font-size: 12px; line-height: 16px;">
            <div>* 비밀번호를 6자 이상 영문, 숫자, 특수문자 7개(!,@,$,%,^,&,*)를 사용하실 수 있습니다.</div>
            <div>* 아이디와 유사하거나 유추하기 쉬운 비밀번호를 등록할 수 없습니다.</div>
            <div>예시) 111abc, aaa1234, aaazzz</div>
          </div>
        </div>
<!--        <div class="join_info_wrap" v-if="from === 'joinForm' || from === 'myInfoForm'">-->
<!--          <div>* 비밀번호를 6자 이상 영문, 숫자, 특수문자 7개(!,@,$,%,^,&,*)를 사용하실 수 있습니다.</div>-->
<!--          <div>* 아이디와 유사하거나 유추하기 쉬운 비밀번호를 등록할 수 없습니다.</div>-->
<!--          <div>예시) 111abc, aaa1234, aaazzz</div>-->
<!--        </div>-->
        <template v-if="from === 'memberForm'">
          <div class="common_form_box_content">
            <div class="common_form_input_wrap one_third_width">
              <label>사이트 이용 여부<span class="fc_red">*</span></label>
              <div>
                <select v-model="useState">
                  <option value="">선택</option>
                  <option v-for="item in useStateList" :key="'useState_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
                </select>
              </div>
            </div>
            <div class="common_form_input_wrap one_third_width">
              <label>시스템 관리 등급<span class="fc_red">*</span></label>
              <div>
                <select v-model="userRole" @change="changeUserRole">
                  <option value="">선택</option>
                  <option v-for="item in userRoleList" :key="'userRole_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
                </select>
              </div>
            </div>
            <div class="common_form_input_wrap one_third_width" :style="userRole !== 3 ? 'display: none;' : ''">
              <label style="display: flex">상위 담당자 정보<span class="fc_red">*</span><span class="fc_primary_blue" style="margin-left: auto" @click="showPopup('상위 담당자 검색', 'MemberSearchPopup', {}, '')">인물검색>></span></label>
              <div>
                <input type="text" v-model="chgUserName" readonly/>
              </div>
            </div>
          </div>
          <div class="common_form_box_content">
            <div class="common_form_input_wrap">
              <label>하위권한설정<span class="fc_red">*</span></label>
              <div>
                <div>
                  <input type="checkbox" id="modem" v-model="subRole1" @click.stop="toggleCheckbox(1)"/>
                  <label for="modem">모뎀현황</label>
                </div>
                <div>
                  <input type="checkbox" id="as" v-model="subRole2" @click.stop="toggleCheckbox(2)"/>
                  <label for="as">모뎀 A/S</label>
                </div>
                <div>
                  <input type="checkbox" id="sq" v-model="subRole4" @click.stop="toggleCheckbox(4)"/>
                  <label for="sq">음영.품질개선</label>
                </div>
                <div>
                  <input type="checkbox" id="stop" v-model="subRole8" @click.stop="toggleCheckbox(8)"/>
                  <label for="stop">회선관리: 정지</label>
                </div>
                <div>
                  <input type="checkbox" id="cancel" v-model="subRole16" @click.stop="toggleCheckbox(16)"/>
                  <label for="cancel">회선관리: 정지해제</label>
                </div>
                <div>
                  <input type="checkbox" id="charge" v-model="subRole32" @click.stop="toggleCheckbox(32)"/>
                  <label for="charge">청구관리</label>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="common_form_box">
        <div class="common_form_box_tit">개인정보</div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap one_third_width">
            <label>이름<span class="fc_red">*</span></label>
            <div>
              <input type="text" v-model="userName" v-if="userPid == null" placeholder="이름을 입력하세요"/>
              <input type="text" v-model="userName" v-else readonly/>
            </div>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap quarter1_width">
            <label>소속<span class="fc_red">*</span> <span class="label_desc" v-if="from === 'myInfoForm'">※ 소속변경은 관리자에게 문의하십시요.</span></label>
            <div v-if="mySession.userRole === 1 || from === 'joinForm'">
              <select v-model="affiliateCode">
                <option value="">미선택</option>
                <option v-for="item in afcList" :key="'afc_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
              </select>
            </div>
            <div v-else>
              <input type="text" :value="affiliateCodeName" readonly/>
            </div>
          </div>
          <div class="common_form_input_wrap quarter2_width">
            <label>본부 <span class="label_desc" v-if="from === 'myInfoForm'">※ 본부변경은 관리자에게 문의하십시요.</span></label>
            <div v-if="mySession.userRole === 1 || from === 'joinForm'">
              <select v-model="ofc1Select" @change="getOfc2List(ofc1Select, true)">
                <option value="">미선택</option>
                <option v-for="item in ofc1List" :key="'ofc1_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
              </select>
              <select v-model="ofc2Select">
                <option value="">미선택</option>
                <option v-for="item in ofc2List" :key="'ofc2_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
              </select>
            </div>
            <div v-else>
              <input type="text" :value="officeCodeName1" readonly/>
              <input type="text" :value="officeCodeName2" readonly/>
            </div>
          </div>
<!--          <div class="common_form_input_wrap quarter3_width">-->
<!--            <label>소속 <span class="label_desc" v-if="from === 'myInfoForm'">※ 소속변경은 관리자에게 문의하십시요.</span></label>-->
<!--            <div v-if="mySession.userRole === 1 || from === 'joinForm'">-->
<!--              <select v-model="affiliateCode">-->
<!--                <option value="">미선택</option>-->
<!--                <option v-for="item in afcList" :key="'afc_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>-->
<!--              </select>-->
<!--              <select v-model="ofc1Select" @change="getOfc2List(ofc1Select, true)">-->
<!--                <option value="">미선택</option>-->
<!--                <option v-for="item in ofc1List" :key="'ofc1_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>-->
<!--              </select>-->
<!--              <select v-model="ofc2Select">-->
<!--                <option value="">미선택</option>-->
<!--                <option v-for="item in ofc2List" :key="'ofc2_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>-->
<!--              </select>-->
<!--            </div>-->
<!--            <div v-else>-->
<!--              <input type="text" :value="affiliateCodeName" readonly/>-->
<!--              <input type="text" :value="officeCodeName1" readonly/>-->
<!--              <input type="text" :value="officeCodeName2" readonly/>-->
<!--            </div>-->
<!--          </div>-->
          <div class="common_form_input_wrap quarter1_width">
            <label>소속팀</label>
            <div>
              <input type="text" v-model="teamName" placeholder="소속팀을 입력하세요"/>
            </div>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap one_third_width">
            <label>직급<span class="fc_red">*</span></label>
            <div>
              <input type="text" v-model="jobRank" placeholder="직급을 입력하세요"/>
            </div>
          </div>
          <div class="common_form_input_wrap one_third_width">
            <label>담당업무<span class="fc_red">*</span></label>
            <div>
              <select v-model="chargeCode">
                <option value="">미선택</option>
                <option v-for="item in rwkList" :key="'rwk_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap quarter1_width each">
            <label>전화번호<span class="fc_red">*</span></label>
            <div>
              <input type="text" v-model="telephone" placeholder="전화번호를 입력하세요"/>
            </div>
          </div>
          <div class="common_form_input_wrap quarter1_width each">
            <label>이동전화번호<span class="fc_red">*</span></label>
            <div>
              <input type="text" v-model="mobilePhone" placeholder="이동전화번호를 입력하세요"/>
            </div>
          </div>
          <div class="common_form_input_wrap quarter1_width each">
            <label>SMS 수신 허용 여부</label>
            <div>
              <select v-model="allowSms">
                <option value="Y">허용</option>
                <option value="N">거부</option>
              </select>
            </div>
          </div>
          <div class="common_form_input_wrap quarter1_width each">
            <label>팩스번호<span class="fc_red">*</span></label>
            <div>
              <input type="text" v-model="faxNumber" placeholder="팩스번호를 입력하세요"/>
            </div>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap quarter3_width">
            <label>이메일(E-mail)<span class="fc_red">*</span></label>
            <div>
              <input type="text" v-model="email1"/>
              <div class="separate">@</div>
              <input type="text" v-model="email2"/>
              <select v-model="email3" @change="changeEmailDomain">
                <option value="">직업입력</option>
                <option :key="'emd_' + item.codePid" v-for="item in emailDomainList" :value="item.codeValue">{{item.codeName}}</option>
              </select>
            </div>
          </div>
          <div class="common_form_input_wrap quarter1_width">
            <label>E-mail 수신 허용 여부</label>
            <div>
              <select v-model="allowEmail">
                <option value="Y">허용</option>
                <option value="N">거부</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="common_form_box">
        <div class="common_form_box_tit">
          <span class="inner_tit">근무지 주소<span class="fc_red">*</span></span>
          <span class="btn_inner_blue" @click="showPostcodePopup">주소 검색</span>
          <span class="label_desc">※ 소속변경은 관리자에게 문의하십시요.</span>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap one_third_width">
            <label>우편번호</label>
            <div>
              <input type="text" v-model="postalCode" readonly/>
            </div>
          </div>
          <div class="common_form_input_wrap one_third_width">
            <label>도로명주소</label>
            <div>
              <input type="text" v-model="addressRoad" readonly/>
            </div>
          </div>
          <div class="common_form_input_wrap one_third_width">
            <label>지번주소</label>
            <div>
              <input type="text" v-model="addressLot" readonly/>
            </div>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap">
            <label>상세주소</label>
            <div>
              <input type="text" v-model="addressDetails" placeholder="상세주소를 입력하세요"/>
            </div>
          </div>
        </div>
      </div>
      <div class="common_form_box">
        <div class="common_form_box_tit">담당지역</div>
        <div class="common_form_box_content area_select">
          <div class="common_form_input_wrap quarter3_width" v-for="(area, index) in areaList" :key="'ac_' + area.acIndex">
            <div>
              <select v-model="area.ac1Select" @change="getAc2List(area, true)">
                <option value="">--시도 선택--</option>
                <option v-for="item in ac1List" :key="'ac1_' + index + '_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
              </select>
              <select v-model="area.ac2Select" @change="getAc3List(area, true)">
                <option value="">--시구군 선택--</option>
                <option v-for="item in area.ac2List" :key="'ac2_' + index + '_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
              </select>
              <select v-model="area.ac3Select">
                <option value="">--구 선택--</option>
                <option v-for="item in area.ac3List" :key="'ac3_' + index + '_' + item.codePid" :value="item.codeValue">{{item.codeName}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="common_bottom_wrap">
        <div class="btn_bottom btn_blue" @click="saveMyInfo">저장</div>
      </div>
    </div>
    <modal name="viewPopup" classes="popup_modal" width="725px" height="auto" scrollable>
      <popup :popup-params="popupParams" @hidePopup="hidePopup" @setSelectedItemList="setSelectedItemList"/>
    </modal>
    <modal name="postcodePopup" :width="400" height="auto">
      <vue-daum-postcode @complete="setAddress"/>
    </modal>
  </div>
</template>

<script>
import { VueDaumPostcode } from 'vue-daum-postcode'
import common from '../../script/common'
import user from '../../script/user'
import Popup from './Popup.vue'
import {defaultLoadingOptions} from '../../script/defaultConfig'

export default {
  components: {
    Popup,
    VueDaumPostcode
  },
  props: ['from'],
  data () {
    return {
      // Common
      mySession: {},
      // Data
      userRoleList: common.getUserRoleList(),
      useStateList: common.useStateList(),
      afcList: [],
      ofcList: [],
      ofc1List: [],
      ofc1Select: '',
      ofc2List: [],
      ofc2Select: '',
      rwkList: [],
      emailDomainList: common.getEmailDomainList(),
      acList: [],
      ac1List: [],
      // Member
      originData: {},
      userPid: null,
      userId: '',
      userIdDuplicate: false,
      password: '',
      passwordConfirm: '',
      userName: '',
      useState: '',
      userRole: '',
      subRole: 0,
      subRole1: false,
      subRole2: false,
      subRole4: false,
      subRole8: false,
      subRole16: false,
      subRole32: false,
      chgUserPid: '',
      chgUserName: '',
      affiliateCode: '',
      affiliateCodeName: '',
      officeCode: '',
      officeCodeName1: '',
      officeCodeName2: '',
      teamName: '',
      jobRank: '',
      chargeCode: '',
      faxNumber: '',
      telephone: '',
      mobilePhone: '',
      allowSms: 'Y',
      email: '',
      email1: '',
      email2: '',
      email3: '',
      allowEmail: 'Y',
      postalCode: '',
      addressRoad: '',
      addressLot: '',
      addressDetails: '',
      affiliateAreas: '',
      areaList: [
        {
          acIndex: 0,
          ac2List: [],
          ac3List: [],
          ac1Select: '',
          ac2Select: '',
          ac3Select: ''
        },
        {
          acIndex: 1,
          ac2List: [],
          ac3List: [],
          ac1Select: '',
          ac2Select: '',
          ac3Select: ''
        },
        {
          acIndex: 2,
          ac2List: [],
          ac3List: [],
          ac1Select: '',
          ac2Select: '',
          ac3Select: ''
        },
        {
          acIndex: 3,
          ac2List: [],
          ac3List: [],
          ac1Select: '',
          ac2Select: '',
          ac3Select: ''
        },
        {
          acIndex: 4,
          ac2List: [],
          ac3List: [],
          ac1Select: '',
          ac2Select: '',
          ac3Select: ''
        }
      ],
      // Popup
      popupParams: {
        title: '',
        component: '',
        data: {}
      }
    }
  },
  mounted () {
    if (this.from != null) {
      if (this.from === 'joinForm') {
        this.init()
      } else {
        common.getSession(response => {
          console.log('getSession', response)
          if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
            this.mySession = response.data.result
            this.init()
          } else {
            common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
            this.$router.replace('/Login')
          }
        })
      }
    }
  },
  watch: {
    telephone () {
      this.telephone = common.getOnlyNumber(this.telephone)
    },
    mobilePhone () {
      this.mobilePhone = common.getOnlyNumber(this.mobilePhone)
    },
    faxNumber () {
      this.faxNumber = common.getOnlyNumber(this.faxNumber)
    },
    email2 () {
      this.email3 = ''
      for (let i = 0; i < this.emailDomainList.length; i++) {
        if (this.emailDomainList[i].codeValue === this.email2) {
          this.email3 = this.emailDomainList[i].codeValue
        }
      }
    }
  },
  methods: {
    toggleCheckbox (val) {
      console.log('toggleCheckbox', val)
      switch (val) {
        case 1: this.subRole1 = !this.subRole1; break
        case 2: this.subRole2 = !this.subRole2; break
        case 4: this.subRole4 = !this.subRole4; break
        case 8: this.subRole8 = !this.subRole8; break
        case 16: this.subRole16 = !this.subRole16; break
        case 32: this.subRole32 = !this.subRole32; break
      }
    },
    init () {
      let intervalCnt = 0
      let interval = setInterval(() => {
        if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
          common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
          common.checkValidateData('session', sessionStorage.getItem('rwkList')) &&
          common.checkValidateData('session', sessionStorage.getItem('acList'))) {
          clearInterval(interval)
          this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
          this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
          this.ofc1List = this.getOfc1List()
          this.rwkList = JSON.parse(sessionStorage.getItem('rwkList'))
          this.acList = JSON.parse(sessionStorage.getItem('acList'))
          this.ac1List = this.getAc1List()
          if (this.from === 'memberForm') {
            if (this.$route.params != null && this.$route.params.type != null && this.$route.params.type === 'edit') {
              this.getUserInfo(this.$route.params.data)
              if (this.$route.params.searchParams != null) {
                this.searchParams = this.$route.params.searchParams
              }
            }
          } else if (this.from === 'myInfoForm') {
            this.getUserInfo(this.mySession.userPid)
          }
        } else if (intervalCnt > 10) {
          clearInterval(interval)
          common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
        } else {
          intervalCnt++
        }
      }, 200)
    },
    checkDuplicate () {
      if (!common.checkValidateData('string', this.userId)) {
        common.amsAlert('general', '아이디를 입력해주세요.')
        return
      }
      if (!common.checkValidateLength('max', this.userId, 32)) {
        common.amsAlert('general', '아이디가 너무 깁니다.')
        return
      }
      this.userIdDuplicate = false
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      user.checkDuplicate({
        userId: this.userId
      }, response => {
        console.log('checkDuplicate', response)
        if (response.data.resultCode === 1) {
          if (response.data.result.body.isDuplicated) {
            common.amsAlert('general', '이미 사용중인 아이디입니다.')
            this.userId = ''
          } else {
            common.amsAlert('general', '사용할 수 있는 아이디입니다.')
            this.userIdDuplicate = true
          }
        } else {
          common.amsAlert('retry', '아이디 중복 확인에 실패했습니다.')
        }
        vueLoadingOverlay.hide()
      })
    },
    changeUserRole () {
      this.chgUserPid = ''
      this.chgUserName = ''
      this.subRole = 63
      this.subRole1 = this.subRole & 1
      this.subRole2 = this.subRole & 2
      this.subRole4 = this.subRole & 4
      this.subRole8 = this.subRole & 8
      this.subRole16 = this.subRole & 16
      this.subRole32 = this.subRole & 32
    },
    showPopup (title, component, data, type) {
      this.popupParams.title = title
      this.popupParams.component = component
      this.popupParams.data = {type: 'C', data: data, userType: type, from: 'STOP'}
      this.$modal.show('viewPopup')
    },
    hidePopup (args) {
      this.$modal.hide('viewPopup')
    },
    setSelectedItemList (args) {
      this.$modal.hide('viewPopup')
      this.chgUserPid = args.data.userPid
      this.chgUserName = args.data.userName
    },
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    getOfc2List (ofc, isSelect) {
      if (isSelect) {
        this.ofc2List = this.ofcList.filter(item => { return item.codeParent === ofc })
      } else {
        return this.ofcList.filter(item => { return item.codeParent === ofc })
      }
    },
    changeEmailDomain () {
      this.email2 = this.email3
    },
    showPostcodePopup () {
      this.$modal.show('postcodePopup')
    },
    setAddress (data) {
      const addressData = common.getDaumAddressData(data)
      this.postalCode = addressData.postalCode
      this.addressRoad = addressData.addressRoad
      this.addressLot = addressData.addressLot
      this.addressDetails = ''
      this.$modal.hide('postcodePopup')
    },
    getAc1List () {
      return this.acList.filter(item => { return item.codeLevel === 0 })
    },
    getAc2List (ac, isSelect) {
      if (isSelect) {
        ac.ac2List = this.acList.filter(item => { return item.codeParent === ac.ac1Select })
      } else {
        return this.acList.filter(item => { return item.codeParent === ac })
      }
    },
    getAc3List (ac, isSelect) {
      if (isSelect) {
        ac.ac3List = this.acList.filter(item => { return item.codeParent === ac.ac2Select })
      } else {
        return this.acList.filter(item => { return item.codeParent === ac })
      }
    },
    getUserInfo (userPid) {
      let params = {}
      if (userPid != null) {
        params.userPid = userPid
      }
      console.log(params)
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      user.getUser(params, response => {
        console.log('getUserInfo', response)
        if (response.data.resultCode === 1) {
          const result = response.data.result.body
          this.originData = result
          this.userPid = result.userPid
          this.userId = result.userId
          this.useState = result.useState
          this.userRole = result.userRole
          this.subRole = result.subRole
          this.subRole1 = this.subRole & 1
          this.subRole2 = this.subRole & 2
          this.subRole4 = this.subRole & 4
          this.subRole8 = this.subRole & 8
          this.subRole16 = this.subRole & 16
          this.subRole32 = this.subRole & 32
          this.chgUserPid = result.chgUserPid
          this.chgUserName = result.chgUserName
          this.userName = result.userName
          this.affiliateCode = result.affiliateCode != null ? result.affiliateCode : ''
          this.affiliateCodeName = ''
          for (let i = 0; i < this.afcList.length; i++) {
            if (this.afcList[i].codeValue === result.affiliateCode) {
              this.affiliateCodeName = this.afcList[i].codeName
            }
          }
          this.officeCode = result.officeCode
          this.ofc1Select = ''
          this.ofc2Select = ''
          this.officeCodeName1 = ''
          this.officeCodeName2 = ''
          if (result.officeCode != null && result.officeCode.length > 0) {
            this.ofc1Select = result.officeCode.substring(0, 5)
            for (let i = 0; i < this.ofc1List.length; i++) {
              if (this.ofc1List[i].codeValue === result.officeCode.substring(0, 5)) {
                this.officeCodeName1 = this.ofc1List[i].codeName
              }
            }
            if (result.officeCode.length > 5) {
              this.ofc2Select = result.officeCode
              this.getOfc2List(result.officeCode.substring(0, 5), true)
              for (let i = 0; i < this.ofc2List.length; i++) {
                if (this.ofc2List[i].codeValue === result.officeCode) {
                  this.officeCodeName2 = this.ofc2List[i].codeName
                }
              }
            }
          }
          this.teamName = result.teamName
          this.jobRank = result.jobRank
          this.chargeCode = result.chargeCode != null ? result.chargeCode : ''
          this.faxNumber = result.faxNumber
          this.telephone = result.telephone
          this.mobilePhone = result.mobilePhone
          this.allowSms = result.allowSms != null && result.allowSms ? 'Y' : 'N'
          this.email = result.email
          if (result.email != null && result.email.length > 0 &&
            result.email.split('@').length === 2) {
            this.email1 = result.email.split('@')[0]
            this.email2 = result.email.split('@')[1]
          }
          this.allowEmail = result.allowEmail != null && result.allowEmail ? 'Y' : 'N'
          this.postalCode = result.postalCode
          this.addressRoad = result.addressRoad
          this.addressLot = result.addressLot
          this.addressDetails = result.addressDetails
          this.affiliateAreas = result.affiliateAreas != null ? result.affiliateAreas : ''
          this.areaList = []
          if (this.affiliateAreas != null && this.affiliateAreas.length > 0 && this.affiliateAreas.split(',').length > 0) {
            const areaList = this.affiliateAreas.split(',')
            for (let i = 0; i < areaList.length; i++) {
              let item = {
                acIndex: i,
                ac2List: [],
                ac3List: [],
                ac1Select: '',
                ac2Select: '',
                ac3Select: ''
              }
              if (areaList[i].length === 4) {
                item.ac1Select = areaList[i]
                item.ac2List = this.getAc2List(item.ac1Select)
              } else if (areaList[i].length === 6) {
                item.ac1Select = areaList[i].substring(0, 4)
                item.ac2List = this.getAc2List(item.ac1Select)
                item.ac2Select = areaList[i]
                item.ac3List = this.getAc3List(item.ac2Select)
              } else if (areaList[i].length === 8) {
                item.ac1Select = areaList[i].substring(0, 4)
                item.ac2List = this.getAc2List(item.ac1Select)
                item.ac2Select = areaList[i].substring(0, 6)
                item.ac3List = this.getAc3List(item.ac2Select)
                item.ac3Select = areaList[i]
              }
              this.areaList.push(item)
            }
          }
          const myAreaCnt = this.affiliateAreas.split(',').length
          if (myAreaCnt < 5) {
            let index = myAreaCnt > 0 && this.affiliateAreas.split(',')[0].length > 0 ? myAreaCnt : 0
            for (let i = index; i < 5; i++) {
              this.areaList.push({
                acIndex: i,
                ac2List: [],
                ac3List: [],
                ac1Select: '',
                ac2Select: '',
                ac3Select: ''
              })
            }
          }
        } else {
          common.amsAlert('retry', '내 정보를 불러오지 못했습니다.')
        }
        vueLoadingOverlay.hide()
      })
    },
    saveMyInfo () {
      if (this.from === 'joinForm') {
        if (!common.checkValidateData('string', this.userId)) {
          common.amsAlert('general', '아이디를 입력해주세요.')
          return
        }
        if (!common.checkValidateLength('max', this.userId, 32)) {
          common.amsAlert('general', '아이디가 너무 깁니다.')
          return
        }
        if (!common.checkValidateData('string', this.password)) {
          common.amsAlert('general', '패스워드를 입력해주세요.')
          return
        }
        if (!common.checkValidateLength('max', this.password, 64)) {
          common.amsAlert('general', '패스워드가 너무 깁니다.')
          return
        }
        if (this.password !== this.passwordConfirm) {
          common.amsAlert('general', '패스워드가 일치하지 않습니다.')
          return
        }
      }
      // 가입신청 혹은 관리자 전용
      if (this.from === 'memberForm') {
        if (!common.checkValidateData('string', this.userRole.toString())) {
          common.amsAlert('general', '시스템 관리 등급을 선택해주세요.')
          return
        }
        if (this.userRole === 3 && !common.checkValidateData('string', this.chgUserPid) && !common.checkValidateData('string', this.chgUserName)) {
          common.amsAlert('general', '상위 담당자를 선택해주세요.')
          return
        }
        if (!common.checkValidateData('string', this.useState.toString())) {
          common.amsAlert('general', '사이트 이용 여부를 선택해주세요.')
          return
        }
      }
      if (!common.checkValidateData('string', this.userName)) {
        common.amsAlert('general', '이름을 입력해주세요.')
        return
      }
      if (!common.checkValidateLength('max', this.userName, 255)) {
        common.amsAlert('general', '이름이 너무 깁니다.')
        return
      }
      if (!common.checkValidateData('string', this.affiliateCode)) {
        common.amsAlert('general', '소속을 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.jobRank)) {
        common.amsAlert('general', '직급을 입력해주세요.')
        return
      }
      if (!common.checkValidateLength('max', this.jobRank, 64)) {
        common.amsAlert('general', '직급이 너무 깁니다.')
        return
      }
      if (!common.checkValidateData('string', this.chargeCode)) {
        common.amsAlert('general', '담당업무를 선택해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.telephone)) {
        common.amsAlert('general', '전화번호를 입력해주세요.')
        return
      }
      if (!common.checkValidateLength('max', this.telephone, 20)) {
        common.amsAlert('general', '전화번호가 너무 깁니다.')
        return
      }
      if (!common.checkValidateData('string', this.mobilePhone)) {
        common.amsAlert('general', '이동전화번호를 입력해주세요.')
        return
      }
      if (!common.checkValidateLength('max', this.mobilePhone, 20)) {
        common.amsAlert('general', '이동전화번호가 너무 깁니다.')
        return
      }
      if (!common.checkValidateData('string', this.faxNumber)) {
        common.amsAlert('general', '팩스번호를 입력해주세요.')
        return
      }
      if (!common.checkValidateLength('max', this.faxNumber, 20)) {
        common.amsAlert('general', '팩스번호가 너무 깁니다.')
        return
      }
      const email = this.email1 + '@' + this.email2
      if (!common.checkValidateData('string', email) ||
        !common.checkValidateData('email', email)) {
        common.amsAlert('general', '이메일을 입력해주세요.')
        return
      }
      if (!common.checkValidateLength('max', email, 255)) {
        common.amsAlert('general', '이메일이 너무 깁니다.')
        return
      }
      if (!common.checkValidateData('string', this.postalCode)) {
        common.amsAlert('general', '주소를 입력해주세요.')
        return
      }
      if (!common.checkValidateData('string', this.addressDetails)) {
        common.amsAlert('general', '상세주소를 입력해주세요.')
        return
      }
      if (!common.checkValidateLength('max', this.addressDetails, 255)) {
        common.amsAlert('general', '상세주소가 너무 깁니다.')
        return
      }
      let data = {
        userId: this.userId,
        affiliateCode: this.affiliateCode,
        userName: this.userName,
        jobRank: this.jobRank,
        chargeCode: this.chargeCode,
        telephone: this.telephone,
        mobilePhone: this.mobilePhone,
        allowSms: this.allowSms === 'Y',
        faxNumber: this.faxNumber,
        email: email,
        allowEmail: this.allowEmail === 'Y',
        postalCode: this.postalCode,
        addressRoad: this.addressRoad,
        addressLot: this.addressLot,
        addressDetails: this.addressDetails
      }
      if (this.from === 'joinForm') {
        data.password = this.password
        if (this.affiliateCode === 'AFC01' || this.affiliateCode === 'AFC02') {
          // 한전 고압/저압 = 한전담당자: 2
          data.userRole = 2
        } else if (this.affiliateCode === 'AFC03' || this.affiliateCode === 'AFC04') {
          // LG유플러스/가이아스 = AS담당자: 4
          data.userRole = 4
        } else if (this.affiliateCode === 'AFC05') {
          // 247번지 = 시스템관리자: 1
          data.userRole = 1
        } else if (this.affiliateCode === 'AFC06') {
          // KDN = 자회사담당자: 3
          data.userRole = 3
        }
      }
      if (this.from === 'memberForm') {
        data.useState = this.useState
        data.userRole = this.userRole
        if (this.userRole === 3) {
          data.chgUserPid = this.chgUserPid
        }
        // 하위 권한
        let subRole = 0
        if (this.subRole1) subRole += 1
        if (this.subRole2) subRole += 2
        if (this.subRole4) subRole += 4
        if (this.subRole8) subRole += 8
        if (this.subRole16) subRole += 16
        if (this.subRole32) subRole += 32
        data.subRole = subRole
      }
      if (common.checkValidateData('string', this.password)) {
        if (!common.checkValidateLength('max', this.password, 64)) {
          common.amsAlert('general', '패스워드가 너무 깁니다.')
          return
        }
        if (this.password !== this.passwordConfirm) {
          common.amsAlert('general', '패스워드가 일치하지 않습니다.')
          return
        }
        data.password = this.password
      }
      if (common.checkValidateData('string', this.ofc1Select)) {
        data.officeCode = this.ofc1Select
        if (common.checkValidateData('string', this.ofc2Select)) {
          data.officeCode = this.ofc2Select
        }
      }
      if (common.checkValidateData('string', this.teamName)) {
        if (common.checkValidateLength('max', this.teamName, 20)) {
          data.teamName = this.teamName
        } else {
          common.amsAlert('general', '소속팀이 너무 깁니다.')
          return
        }
      }
      let affiliateAreasList = []
      this.acList.forEach(ac => {
        if (ac.ac3Select != null && ac.ac3Select !== '') {
          affiliateAreasList.push(ac.ac3Select)
        } else if (ac.ac2Select != null && ac.ac2Select !== '') {
          affiliateAreasList.push(ac.ac2Select)
        } else if (ac.ac1Select != null && ac.ac1Select !== '') {
          affiliateAreasList.push(ac.ac1Select)
        }
      })
      if (affiliateAreasList.length > 0) {
        data.affiliateAreas = affiliateAreasList.join(',')
      }
      const checkedData = common.checkChangedData(data, this.originData)
      // console.log('checkedData', checkedData)
      // return
      if (this.userPid != null) {
        if (Object.keys(checkedData).length > 0) {
          checkedData.userPid = this.originData.userPid
        } else {
          common.amsAlert('general', '수정된 내용이 없습니다.')
          return
        }
        console.log('post', checkedData)
        let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
        user.user(checkedData, response => {
          console.log('user: post', response)
          if (response.data.resultCode === 1) {
            if (this.from === 'memberForm') {
              common.amsAlert('general', '사용자를 수정했습니다.')
              vueLoadingOverlay.hide()
              this.$router.push({
                name: 'MemberList',
                params: {
                  type: 'return',
                  searchParams: this.searchParams
                }
              })
            } else if (this.from === 'myInfoForm') {
              common.amsAlert('general', '내 정보를 수정했습니다.')
              vueLoadingOverlay.hide()
              window.location.reload()
            }
          } else {
            common.amsAlert('retry', this.from === 'memberForm' ? '사용자를 수정하지 못했습니다.' : '내 정보를 수정하지 못했습니다.')
            vueLoadingOverlay.hide()
          }
        })
      } else {
        console.log('put', checkedData)
        let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
        user.signup(checkedData, response => {
          console.log('signup', response)
          if (response.data.resultCode === 1) {
            if (this.from === 'joinForm') {
              common.amsAlert('general', '계정신청을 완료했습니다.\n관리자가 신청을 승인한 후 사이트 이용이 가능합니다.')
              vueLoadingOverlay.hide()
              this.$router.replace('/Login')
            } else if (this.from === 'memberForm') {
              common.amsAlert('general', '사용자를 등록했습니다.')
              vueLoadingOverlay.hide()
              this.$router.push({
                name: 'MemberList',
                params: {
                  type: 'return',
                  searchParams: this.searchParams
                }
              })
            }
          } else {
            common.amsAlert('retry', this.from === 'joinForm' ? '계정신청을 완료하지 못했습니다.' : '사용자를 등록하지 못했습니다.')
            vueLoadingOverlay.hide()
          }
        })
      }
    }
  }
}
</script>

<style scoped>
#commonMemberForm {
  display: flex;
  flex-direction: column;
  margin: 36px auto 46px;
}

#commonMemberForm .common_bottom_wrap > .btn_blue {
  margin: auto 0 auto auto;
}

#commonMemberForm .common_form_box > .common_form_box_content.area_select {
  gap: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/CommonMemberForm.vue